module.exports = __webpack_public_path__ + "static/media/demofilm-drawer-mf-ikon@3x.c7ab2770.png";